import React, { useState, useRef, useEffect } from 'react'
import { Card, CardBody, Modal, Button, Form } from "react-bootstrap";
import { useAuth } from '../../contexts/AuthContext';
import { formatDateFull } from '../solution/utils/AppUtil';
import { CastType, IQuery, IQuerySelectData, IUploadFilePreviewItem, IWhere, IStore, IStockTake, IStockTakeLine, IStockReportReview, ISelectedScannedItem, IQueryTableData } from '../solution/Interfaces';
import ShowErrorAlert  from '../ShowErrorAlert';
import { Ban, Check, FileBarChart, FileUp, Pencil, Save, ScanLine, UserCog, X } from 'lucide-react';



interface IComponent {
  store: IStore;
  close: () => void;
  isCycleCount?: boolean; // Optional boolean prop
}

interface IStockTakeGroupCodes {
  code: string;
  name: string;
};

export const StockTake:React.FC<IComponent | null> = (props) => {

  const { fetchData, responseErrorMessage, showErrorAlert, responseStatus, userDetail }  = useAuth();
  const queryUrl: string = `${process.env.REACT_APP_BASE_URL}/${"query/data"}`;
  const queryUrlSelectNoCount: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data"}`;
  const queryUrlSelectWithCount: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data?includeCount=true"}`;
  const queryUrlTable: string = `${process.env.REACT_APP_BASE_URL}/${"query/table/data"}`
  const fetchStockTakeActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/STOCKTAKE-ACTIONS/run`; 
  const fetchStockTakeSessionActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/STOCKTAKE-SESSION-ACTIONS/run`; 
  const fetchStockTakeLineActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/STOCKTAKE-LINE-ACTIONS/run`; 
  const fetchStockTakeFilePreviewQuertUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/SCAN-FILE-SUMMARY/run`; 
  const fetchStockTakeCategoryQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/FETCH-SAP-ITEM-GROUPS/run`; 

 
  const [stockTakeState, setStockTakeState] = useState<IStockTake[]>([]);
  const [stockTakeLineState, setStockTakeLineState] = useState<IStockTakeLine[]>([]);
  const [selectedStockTake, setSelectedStockTake] = useState<IStockTake | null>(null);
  const [checkSelectedStockTake, setCheckSelectedStockTake] = useState<IStockTake | null>(null);
  const [selectedStockTakeValid, setSelectedStockTakeValid] = useState<IStockTake | null>(null);
  const [selectedReportReview, setSelectedReportReview] = useState<IStockReportReview[]>([]);
 
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportPreviewModal, setShowReportPreviewModal] = useState<boolean>(false);
  const [showCloseRecordModal, setShowCloseRecordModal] = useState<boolean>(false);
  const [viewMode, setViewMode] = useState<'file' | 'scan' | 'default'>('default'); 
  const [comment, setComment] = useState<string>(''); // Separate state for comment

  const [showStockTakeCreationModal, setShowStockTakeCreationModal] = useState<boolean>(false);
  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const [fetchedCategories, setFetchedCategories] = useState<IStockTakeGroupCodes[]>([])


  const [showHqCycleCountCreationModal, setShowHqCycleCountCreationModal] = useState<boolean>(false);
  const fileArticleRef = useRef<HTMLInputElement | null>(null);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const scanRef = useRef<HTMLInputElement | null>(null);
  const fileRef = useRef<HTMLInputElement | null>(null);
  const commentRef = useRef<HTMLTextAreaElement | null>(null);

  const [submitRefreshData, setSubmitRefreshData] = useState<boolean>(false); 
  const [submitRefreshLineData, setSubmitRefreshLineData] = useState<boolean>(false);
  
  const [currentSession, setCurrentSession] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [reportLoading, setReportLoading] = useState<boolean>(false);
  const [downLoadLoading, setDownLoadLoading] = useState<boolean>(false);
  const [lineDataCheckLoading, setLineDataCheckLoading] = useState<boolean>(false);
  const [hasBeenCompleted, setHasBeenCompleted] = useState<boolean>(false);

  const [selectedScannedItem, setSelectedScannedItem] = useState<ISelectedScannedItem | null>(null);  
  const [showCustomQuantitySection, setShowCustomQuantitySection] = useState<boolean>(false);
  const [customQuantity, setCustomQuantity] = useState<string>('1');

  const [editingRowId, setEditingRowId] = useState<string | null>(null);
  const [editedQty, setEditedQty] = useState<Record<string, number>>({}); 
  const [inputDraft, setInputDraft] = useState<Record<string, string>>({});

  const [previewFileUpload, setPreviewFileUpload] = useState<boolean>(false);
  const [previewUploadedFileData, setPreviewUploadedFileData] = useState<IUploadFilePreviewItem[]>([]);
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [previewFailed, setPreviewFailed] = useState<boolean>(false);

  const [shouldResetAfterClose, setShouldResetAfterClose] = useState(false);

  const [selectedMethod, setSelectedMethod] = useState<"none" | "file" | "manual">("none");
  const [articleCodes, setArticleCodes] = useState<string[]>([]);
  const [newArticleCode, setNewArticleCode] = useState("");

  const defaultStockTakeQuery = {
    tableName: "sa_stocktake", 
    where: 'location = :location AND status IN (:status) AND is_cycle_count = :is_cycle_count',
    orderBy: "created ASC",
    params: { 'location': `${props?.store.code}`, 'status': ["CLOSED", "OPEN"], 'is_cycle_count': props?.isCycleCount }
  }; 

  const [queryState, setQueryState] = useState<IQueryTableData>(defaultStockTakeQuery); 


 //Query Line State
 const [queryLineState, setQueryLineState] = useState<IQuery>({
    tableName: "sa_stocktake_line",
    select: [],
    groupBy: [],
    join: [{
      relationship: 'item', 
      joinType: 'LEFT',
    }],
    orderBy: [ 
        {
            fullColumnName: "created",
            direction: "ASC",
            cast: CastType.TIMESTAMP
        }
    ],
    where:[
        {
            fullColumnName: "stocktake_id",
            value: selectedStockTake?.id, 
            operator: "EQ",
            cast: CastType.UUID
        }
    ],
    mainTableOnly: false,
    includeExtraColumns: true,
    includeControlColumns: true,
    modifiedAfter: null,
    touchedBefore: null,
    isDirty: null,
    // pageNum: 0,
    // pageSize: 100,
    frontEndOnly: null
 });

  const defaultQueryState: IQuerySelectData = {
           appCode: "ares",
           selectCode: "scan-item",  
           params: {}
       };   
         
  const [querySelectState, setQuerySelectState] = useState<IQuerySelectData>(defaultQueryState);



 useEffect(() => {
  setLoading(true); 
  fetchData(queryUrlTable, {method:"POST", body: JSON.stringify(queryState)}, processData, cleanUpLoader);
  }, [queryState, submitRefreshData]);

  useEffect(() => {
    if(selectedStockTake){
        const queryLine = {...queryLineState}
        queryLine.where = [
            {
                fullColumnName: "stocktake_id",
                value: selectedStockTake?.id,
                operator: "EQ",
                cast: CastType.UUID
            },{
              fullColumnName: "session_num",
              value: currentSession, 
              operator: "EQ",
              cast: CastType.NUMERIC
            }           
        ]
        setLoading(true); 
        fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryLine)}, processLineData, cleanUpLoader);
    }
  }, [selectedStockTake, submitRefreshLineData]);

  useEffect(() => {
    if (selectedStockTake && scanRef.current) {
        scanRef.current.focus();
    }
    if (selectedStockTake && fileRef.current) {
        fileRef.current.focus();
    }
  }, [selectedStockTake]);

  useEffect(() => {
    if (commentRef.current) {
        commentRef.current.focus();
    }
  }, [showCloseRecordModal])

   useEffect(() => {
        if(previewFileUpload && (responseStatus === "400" || responseStatus === "404")){
            setPreviewUploadedFileData([]);
            setPreviewLoading(false);
            setPreviewFailed(true);
        }
    }, [responseStatus, previewFileUpload])

  //default clean up loader
  const cleanUpLoader = () => {
    setLoading(false);
    setLineDataCheckLoading(false);
  }

  //default report up loader
  const cleanUpReportLoader = () => {
      setReportLoading(false);
  }

  //default complete stock take / cycle count loader
  const cleanUpLoaderComplete = () => {
    setLoading(false);
    setHasBeenCompleted(false);
    setComment("");
  }

  //default download loader
  const cleanUpLoaderDownLoad = () => {
    setDownLoadLoading(false);
  }


  //processing data 
  const processData = (result: any) => {
  
   const stockTakes: IStockTake[] = [];
        
   for(const key in result?.data){
       stockTakes.push({ 
        ...result.data[key].data, 
        ...result.data[key].control, 
        ...{id: result.data[key].id},
        ...result.data[key].undefined
      });
   }

   stockTakes.sort((a, b) => {
    if (a.status === "OPEN" && b.status !== "OPEN") {
        return -1; // "OPEN" goes to the top
    }
    if (a.status !== "OPEN" && b.status === "OPEN") {
        return 1; // "OPEN" goes to the top
    }
    return 0; // If both have the same status, maintain the original order
   });

   setStockTakeState(stockTakes);
};

 //processing line data
 const processLineData = (result: any) => {
  
    const stockTakeLines: IStockTakeLine[] = result?.data?.map((entry: any) => {
      const control = entry.control || {};
      const data = entry.data || {};

      return {
        id: control.id,
        stocktake_id: data.stocktake_id, 
        created_by: control.created_by,
        created: control.created,
        updated: control.updated,
        session_num: data.session_num,
        item_code: data.item_code,
        item_name: data['item.name'],
        item_barcode: data['item.barcode'],
        qty: data.qty
      };
    }) || [];

    setStockTakeLineState(stockTakeLines);

};

//process category group data
const processCategoryGroup = (result: any) => {
  // result is already the array of categories
  setFetchedCategories(result);
}
  
 //handle process of creating stock take or cycle count
 const handleCreationProcess = (is_cycle_count?: boolean) => {

    // if undefined or null, do nothing
    if (is_cycle_count === undefined) return;
     
    // Indicates this if its a stock take.
    if(!is_cycle_count){
       //triggers the modal to create a stock take. 
         fetchData(fetchStockTakeCategoryQueryUrl,
          { method: "GET" }, 
          (result: any, status: string) =>  { 
              if(status === "200"){
                //Causes refresh on data 
                processCategoryGroup(result);
                setShowStockTakeCreationModal(true);
              }
          });       
    }

    // Indicates this is a cycle count.
    if(is_cycle_count){
      // standard user
      console.log(`user`,userDetail?.roles ); 
      if (userDetail?.roles?.length === 0 || userDetail?.roles?.includes("store_management")) {
        if (props?.store?.code) {
          setLoading(true); 
          fetchData(fetchStockTakeActionsQueryUrl, 
            {method:"POST", body: JSON.stringify({ location: props?.store.code, is_cycle_count: props.isCycleCount })}, 
            (result: any, status: string) =>  { 
                if(status === "200"){
                  // Causes refresh on data  
                  setSubmitRefreshData(prev => !prev);
                }
            }, cleanUpLoader);
        }else{
          return; // Prevent further execution if the code is not available
        }

      } else if (userDetail?.roles?.includes("HQ")) {
        // HQ user
        setShowHqCycleCountCreationModal(true); 
      } else {
        //return if not standard user or hq user 
        return; 
      }
      
    }
 }

  //process of creating a stock take
  const handleCreateStockTakeSubmit = () => {
    if (props?.store?.code && selectedCategories.length !== 0 && !props.isCycleCount) {
      setLoading(true); 
      fetchData(fetchStockTakeActionsQueryUrl, 
        {method:"POST", body: JSON.stringify({ location: props?.store.code, is_cycle_count: props.isCycleCount, item_groups: selectedCategories })}, 
        (result: any, status: string) =>  { 
            setSelectedCategories([]);
            if(status === "200"){
              // Causes refresh on data  
              setSubmitRefreshData(prev => !prev);
            }
        }, cleanUpLoader);
    }else{
      return; // Prevent further execution if the code is not available
    }
  };


  const handleCreateCycleCountSubmit = () => {
      if (!props?.store?.code) return; // exit early if no store code

      setLoading(true);
      const location = props.store.code;

      const resetInputs = () => {
        setArticleCodes([]);
        if (fileArticleRef.current) fileArticleRef.current.value = "";
        setSelectedMethod('none');
        setNewArticleCode("");
        setSelectedFile(null);
      };

      // --- File upload case ---
      if (fileArticleRef?.current?.files?.length && selectedFile && selectedMethod === "file") {
        
        const formData = new FormData();
        formData.append('f', selectedFile);
        formData.append('j1',new Blob([JSON.stringify({ location, is_cycle_count: true })], { type: 'application/json' }));

        const headers = new Headers();
        headers.append("Content-Type", "multipart/formdata");

        fetchData(
          fetchStockTakeActionsQueryUrl,
          { method:"POST", body: formData, headers: headers }, 
          (result: any, status: string) => {
            if (status === "200") {
              setSubmitRefreshData(prev => !prev);
            }
            resetInputs();
          },
          cleanUpLoader
        );

      } else if (articleCodes?.length && selectedMethod === "manual") {
        // --- Article codes case ---
        fetchData(fetchStockTakeActionsQueryUrl,
          {method: "POST", body: JSON.stringify({ location, is_cycle_count: true, article_codes: articleCodes })},
          (result: any, status: string) => {
            if (status === "200") {
              setSubmitRefreshData(prev => !prev);
            }
            resetInputs();
          },
          cleanUpLoader
        );

      } else {
        // --- Default cycle count ---
        fetchData(
          fetchStockTakeActionsQueryUrl,
          { method: "POST", body: JSON.stringify({ location, is_cycle_count: true }) },
          (result: any, status: string) => {
            if (status === "200") {
              setSubmitRefreshData(prev => !prev);
            }
            resetInputs();
          },
          cleanUpLoader
        );
      }
  };



   //DELETE STOCK TAKE Record
   const handleDeleteSubmit = (stockTakeID: string) => {
      if(stockTakeID){
        setLoading(true); 
        fetchData(fetchStockTakeActionsQueryUrl,
          { method: "DELETE", body: JSON.stringify({ stocktake_id: stockTakeID })}, 
          (result: any, status: string) =>  { 
              //processData(result);
              if(status === "200"){
                //Causes refresh on data 
                setSubmitRefreshData(prev => !prev);
                setCheckSelectedStockTake(null);
              }else{
                setCheckSelectedStockTake(null);
              }
          }, cleanUpLoader); 
      }else{
        return;
      }
   };


   //CLOSE STOCK TAKE Record 
   const handleCloseSubmit = (stockTakeID: string) => {
      if(stockTakeID){
      setLoading(true); 
      setHasBeenCompleted(true);
      fetchData(fetchStockTakeActionsQueryUrl,
        { method: "PUT", body: JSON.stringify({ stocktake_id: stockTakeID, comment: comment })}, 
        (result: any, status: string) =>  { 
           //processData(result);
           if(responseStatus === "200"){
              //Causes refresh on data 
              setSubmitRefreshData(prev => !prev);
           }
        }, cleanUpLoaderComplete); 
    }else{
      return;
    } 
   };


   //SCANNING BARCODES
   // Add the event handler for "Enter" key press
   const handleScanKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, stockTakeID: string) => {
    if (event.key === 'Enter') {
        event.preventDefault();  // Prevent default behavior (if needed)
        handleScanSubmit(stockTakeID); 
    }
   };


  const handleScanSubmit = (stockTakeID: string) => {

        setLoading(true); 
        const item_code = scanRef.current?.value.trim();

        if (!item_code || !currentSession) {
          setLoading(false);
          return;
        }

        const queryPayload = {
              ...querySelectState,
              params: { ...querySelectState.params, scan_code: item_code },
        };

        let shouldRunLineFetch = true;

        // Step 1: Fetch item metadata (to check item group, etc.)
        fetchData(
            queryUrlSelectNoCount,
            { method: "POST", body: JSON.stringify(queryPayload) },
            (result: any, status: string) => {
                if (status === "200") {
                    const item = result?.data?.[0]?.data;
                    const id = result?.data?.[0]?.id;

                    if (item && id) {
                        const itemGroup = item.item_group;

                        const scannedItem: ISelectedScannedItem = {
                            id,
                            barcode: item.barcode,
                            item_code: item.item_code,
                            item_group: itemGroup,
                            name: item.name,
                            product_code: item.product_code,
                        };

                        setSelectedScannedItem(scannedItem);

                        if (itemGroup === "Jibbitz") {
                            setShowCustomQuantitySection(true);
                            shouldRunLineFetch = false; // Skip fetch for Jibbitz
                        }
                    }
                }

                // Step 2: Conditionally fetch receipt line data
                if (shouldRunLineFetch) {
                    fetchData(fetchStockTakeLineActionsQueryUrl,
                      { method:"POST", body: JSON.stringify({ stocktake_id: stockTakeID, session_num: currentSession,  barcode: item_code})}, 
                      (result: any, status: string) =>  { 

                      if(status === "200"){
                          setSubmitRefreshLineData(prev => !prev);
                        }
                      }, cleanUpLoader); 
                } else {
                    setLoading(false); // Clean up if skipping line fetch
                }
            }
        );

        // Reset scanRef after submission
        if (scanRef.current) {
            scanRef.current.value = "";
        }  
    
  };



  const handleQuantitySubmit = (stocktake_id: string) => {

       if (!selectedScannedItem || !stocktake_id || !currentSession) return;

       const { item_code, barcode } = selectedScannedItem;
       const code = item_code?.trim() || barcode?.trim();

       const parsedQty = Math.max(1, parseInt(customQuantity) || 1);

       const payload = {
        stocktake_id: stocktake_id,
        session_num: currentSession,
        barcode: code,
        qty: parsedQty
       };

       setLoading(true);

       //console.log(`This is the payload`, payload);

        fetchData(fetchStockTakeLineActionsQueryUrl,
          { method:"POST", body: JSON.stringify(payload)}, 
          (result: any, status: string) =>  { 

           if(status === "200"){
               setSubmitRefreshLineData(prev => !prev);
                setShowCustomQuantitySection(false);
                setSelectedScannedItem(null);
                setCustomQuantity('1');
            }
          }, cleanUpLoader); 

        // Reset scanRef after submission
        if (scanRef.current) {
            scanRef.current.value = "";
        }  
    };


  //FILE WITH BARCODES
  // Handle file/folder selection
  const handleFolderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
    
      if (file) {
        const isXlsx = file.name.toLowerCase().endsWith(".xlsx");
    
        if (isXlsx) {
          setSelectedFile(file); 
        } else {
          setSelectedFile(null); 
        }
      } else {
        setSelectedFile(null); 
      }
  };

  const handleCancelFilePreview = () => {
      setPreviewFileUpload(false);
      setPreviewUploadedFileData([]);
      setPreviewLoading(false);
      setPreviewFailed(true);

      // Reset fileRef after submission
      setSelectedFile(null);
      if (fileRef.current) {
        fileRef.current.value = ''; 
      }
  }

  //Handling the file preview
  const handleFilePreview = () => {
      if(selectedFile){

        setPreviewFileUpload(true);
        setPreviewLoading(true);

        // how to do a multipe part form posts javascript  
        const formData = new FormData();
        formData.append('file', selectedFile);

        const headers = new Headers();
        headers.append("Content-Type", "multipart/formdata");

        fetchData(fetchStockTakeFilePreviewQuertUrl, 
        { method:"POST", body: formData, headers: headers }, 
        ((result: any, status: string) =>  { 
          if(status === "200"){
              setPreviewLoading(false);
              setPreviewUploadedFileData(result || []);
              setPreviewFailed(false);
          }else{
              setPreviewUploadedFileData([]);
              setPreviewLoading(false);
              setPreviewFailed(true);
           }
        })); 

      }else{
        return;
      }
  }

  const handleFileSubmit = (stockTakeID: string) => {
     if(selectedFile){
       // how to do a multipe part form posts javascript  
       const formData = new FormData();
       formData.append('f', selectedFile);
       formData.append('j1', new Blob([JSON.stringify({ stocktake_id: stockTakeID })], { type: 'application/json' }));

       const headers = new Headers();
       headers.append("Content-Type", "multipart/formdata");

       setLoading(true); 
       fetchData(fetchStockTakeSessionActionsQueryUrl, 
        { method:"POST", body: formData, headers: headers }, 
        ((result: any, status: string) =>  { 
          if(status === "200"){
             setSubmitRefreshData(prev => !prev);
             handleCancelFilePreview();
             setViewMode('default');
          }
         }), cleanUpLoader); 
      
     }else{
      return;
     }
  };
  //end point for getting a report of stock take. 


  //handle close view 
  const handleCloseView = (stocktake:IStockTake) => {
      setSelectedStockTakeValid(stocktake)
      setComment(stocktake?.comment ?? "");
      setShowCloseRecordModal(true);
      setLineDataCheckLoading(true);

      const queryLine = {...queryLineState}
      queryLine.where = [
          {
              fullColumnName: "stocktake_id",
              value: stocktake?.id,
              operator: "EQ",
              cast: CastType.UUID
          }         
      ]

      fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryLine)}, processLineData, cleanUpLoader);
  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value); 
  };


   //handle delete screen view 
   const handleDeleteView = (stocktake:IStockTake) => {
    setCheckSelectedStockTake(stocktake);
    setShowModal(true);
  };

  //handle file screen view 
  const handleFileView = (stocktake: IStockTake) => {
    setViewMode('file');
    setSelectedStockTake(stocktake);
  };


  //handle scan screen view 
  const handleScanView = (stocktake: IStockTake) => {
    setViewMode('scan');
    setSelectedStockTake(stocktake);

    setLoading(true); 
    fetchData(fetchStockTakeSessionActionsQueryUrl, 
      {method:"POST", body: JSON.stringify({ stocktake_id: stocktake.id })}, 
      (result: any, status: string) =>  { 
        if(status === "200"){
          setCurrentSession(result?.session_num);
        } 
      }, cleanUpLoader);
  };

  //handle report screen view 
  const handleReportView = async (stocktake: IStockTake) => {
    setSelectedStockTake(stocktake);
    setShowReportPreviewModal(true);


    const queryStateStocTakeReport: IQuerySelectData = {
        appCode: "ares",
        selectCode: "stocktake-report",  
        where: 'stocktake_id = :id',
        params: { 'id': `${stocktake.id}`}
    }; 

    const queryStateCycleCountReport: IQuerySelectData = {
          appCode: "ares",
          selectCode: "stocktake-report",    
          where: `stocktake_id = :id AND scanned = :scanned`,
          params: { 'id': `${stocktake.id}`, 'scanned': true }
    }; 


    const queryState = props?.isCycleCount ? queryStateCycleCountReport : queryStateStocTakeReport;

    setReportLoading(true);
    fetchData(queryUrlSelectWithCount, {method:"POST", body: JSON.stringify(queryState)}, (result: any) => processReportData(result), cleanUpReportLoader);
  };

  const processReportData = (result: any) => {

    //console.log(result); 
    const reportPreview: IStockReportReview[] = [];
         
    for(const key in result?.data){
        reportPreview.push({
          ...result.data[key].data,
          ...result.data[key].key,
        });
    }
 
    setSelectedReportReview(reportPreview);
  };

  //handling reporting down
  const handleReportDownLoad = (selectedStockTake:IStockTake) => {

     setDownLoadLoading(true);
     fetchData(`${fetchStockTakeActionsQueryUrl}?stocktake_id=${selectedStockTake.id}`, {method: "GET" }, (result: any) =>  processStockTakeReportExcel(result, selectedStockTake.reference), cleanUpLoaderDownLoad);
  }


  const processStockTakeReportExcel = async (result: any, stockTakeReference: string) => {
    
    // Create a download link for the Blob
    const url = URL.createObjectURL(result);
    // Create a temporary <a> element to trigger the download
    const a = document.createElement('a');
    a.href = url;
    //a.download = `${confirmShipmentNo}.xlsx`; // Set the default filename here
    a.download = `${stockTakeReference}.xlsx`; // Set the default filename here
    document.body.appendChild(a);
    a.click();
 } 

  const handleBackToStockTakes = () => {
    //handling the resetting to default view
    setViewMode('default');
    setSelectedStockTake(null);
    setCurrentSession(null); //reset session
    setSelectedScannedItem(null);
    setCustomQuantity('1');
    setEditingRowId(null); // exit edit mode
    setEditedQty({});
    setInputDraft({});
    setShowCustomQuantitySection(false); 

    handleCancelFilePreview();

    // Reset fileRef after submission
    setSelectedFile(null);
    if (fileRef.current) {
      fileRef.current.value = ''; 
    }
  };

  const handleCloseForm = () => {
    setSelectedScannedItem(null);
    setCustomQuantity('1');
    setShowCustomQuantitySection(false); 
  };


  const handleEditClick = (id: string, initialQty: number) => {
    setEditingRowId(id);
    setEditedQty(prev => ({ ...prev, [id]: initialQty }));
    setInputDraft(prev => ({ ...prev, [id]: initialQty.toString() }));
  };

  const handleQtyDraftChange = (id: string, value: string) => {
    setInputDraft(prev => ({ ...prev, [id]: value }));
  };

  const handleBlur = (id: string) => {
      const draftValue = inputDraft[id];
      const parsed = parseInt(draftValue, 10);
      setEditedQty(prev => ({ ...prev, [id]: isNaN(parsed) ? 0 : parsed }));
  };

  const handleSaveClick = (id: string) => {
      const qty = editedQty[id];
      const barcode = stockTakeLineState.find(line => line.id === id)?.item_code;
      const stocktake_id = selectedStockTake?.id;
      const session_num = currentSession;

      if (!barcode || qty === undefined || stocktake_id === undefined || !session_num) return;


      const payload = {
        stocktake_id,
        barcode,
        session_num,
        qty: qty,
        mode: 'exact'
      };

      // Perform your save operation here (e.g., API call)
      fetchData(fetchStockTakeLineActionsQueryUrl,
      { method:"POST", body: JSON.stringify(payload)}, 
      (result: any, status: string) =>  { 
          if(status === "200"){
              setSubmitRefreshLineData(prev => !prev); 
              setEditingRowId(null); // exit edit mode
              setEditedQty({});
              setInputDraft({});
          }
      }, cleanUpLoader);
  };


  //Performing check to determine if all stock takes / cycles are all closed. 
  const allClosed = stockTakeState.every(item => item.status === 'CLOSED');

  //Performing Total Calculations
  const totalOnHandStart = selectedReportReview.reduce((total, report) => total + report.on_hand_start, 0);
  const totalCommittedStart = selectedReportReview.reduce((total, report) => total + report.committed_start, 0);
  const totalAvailableStart = selectedReportReview.reduce((total, report) => total + report.available_start, 0);
  const totalScannedQty = selectedReportReview.reduce((total, report) => total + report.scanned_qty, 0);
  const totalScannedVarience = selectedReportReview.reduce((total, report) => total + report.scanned_variance , 0);
  const totalOnHandFinal = selectedReportReview.reduce((total, report) => total + report.on_hand_final , 0);
  const totalCommittedFinal = selectedReportReview.reduce((total, report) => total + report.committed_final, 0);
  const totalActaulVarience = selectedReportReview.reduce((total, report) => total + report.actual_variance, 0);

 

   const DisabledReportBtn = () => {
        return (
            <span className="btn h-100 d-flex align-items-center gap-1" title="Report"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
             >
             <FileBarChart style={{ width: "17px", height: "17px", color: "#6c757d" }} />
           </span>
        ) 
    } 

   const DisabledFileBtn = () => {
        return (
            <span className="btn h-100 d-flex align-items-center gap-1" title="Upload File"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
             >
             <FileUp style={{ width: "17px", height: "17px", color: "#6c757d" }} />
           </span>
        ) 
    } 
   

    const DisabledScanBtn = () => {
        return (
            <span className="btn h-100 d-flex align-items-center gap-1" title="Scan"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
             >
             <ScanLine style={{ width: "17px", height: "17px", color: "#6c757d" }} />
           </span>
        ) 
    } 

    const DisabledCheckBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Close Record"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <Check style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
    } 

  const DisabledDeleteBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Remove Record"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <X style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
  } 

  const DisabledEditQtyBtn = () => {
            return (
            <span className="btn h-100 d-flex align-items-center gap-1" title="Edit Quantity"
                style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
            >
            <Pencil style={{ width: "17px", height: "17px", color: "#6c757d" }} />
            </span>
        )
  } 

  const DisabledSaveQtyBtn = () => {
      return (
      <span className="btn h-100 d-flex align-items-center gap-1" title="Save Quantity"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
          <Save style={{ width: "17px", height: "17px", color: "#6c757d" }} />
      </span>
      )
  } 


  

  const thStyle = {
      border: '1px solid #deebed',
      color: "#6c757d",
      padding: "8px",
      whiteSpace: "nowrap" as const,
      backgroundColor: "#f8f9fa",
  };

  const tdStyle = {
      borderBottom: "1px solid #dee6ed",
      borderRight: "1px solid #dee6ed",
      padding: "8px",
      whiteSpace: "nowrap" as const,
  };


  
  const allSelected = fetchedCategories.length > 0 && fetchedCategories.every((c) => selectedCategories.includes(Number(c.code)));

  const handleCategoryChange = (category: IStockTakeGroupCodes | "All", checked: boolean) => {
    if (category === "All") {
      if (checked) {
        // ensure all codes are numbers
        setSelectedCategories(fetchedCategories.map((c) => Number(c.code)));
      } else {
        setSelectedCategories([]);
      }
    } else {
      const codeNumber = Number(category.code); // convert to number
      if (checked) {
        setSelectedCategories((prev) => [...prev, codeNumber]);
      } else {
        setSelectedCategories((prev) => prev.filter((c) => c !== codeNumber));
      }
    }
  };


 

  const handleRadioClick = (method: "file" | "manual") => {
      if (selectedMethod === method) {
        // Clicking the same one again clears everything
        setSelectedMethod("none");
        setArticleCodes([]);
        setNewArticleCode("");
        if (fileArticleRef.current) {
            fileArticleRef.current.value = ""; // reset file input
        }
      } else {
        // Switching between methods
        setSelectedMethod(method);

        if (method === "file") {
          // Clear manual codes when switching to file
          setArticleCodes([]);
          setNewArticleCode("");
        } else if (method === "manual") {
          // Clear file when switching to manual
          if (fileArticleRef.current) {
            fileArticleRef.current.value = "";
          }
        }
      }
    };


  // Add article code
  const handleAddArticleCode = () => {
    if (newArticleCode.trim() === "") return; // prevent empty
    if (articleCodes.includes(newArticleCode.trim())) {
      setNewArticleCode("");
      return;
    }; // prevent duplicates

    setArticleCodes((prev) => [...prev, newArticleCode.trim()]);
    setNewArticleCode(""); // clear input
  };

  // Delete article code
  const handleDeleteArticleCode = (code: string) => {
    setArticleCodes((prev) => prev.filter((c) => c !== code));
  };

  const handleCloseHqCycleCountCreationModal = () => {
    setShowHqCycleCountCreationModal(false);
    setSelectedMethod('none');
    setArticleCodes([]);
    setNewArticleCode("");
    setSelectedFile(null);
    if (fileArticleRef.current) {
        fileArticleRef.current.value = ""; // clear file input
    }
  };
   
  return (
    <>
        { showErrorAlert && <ShowErrorAlert message={responseErrorMessage} /> } 
         <Card>
                <Card.Header>
                    <Card.Title>{` ${props?.isCycleCount ? "Cycle Count" : "Stock Take"} - [${props?.store.name}]`}</Card.Title>                       
                </Card.Header>
                <CardBody>
                  <div className="d-flex gap-1">
                      <button
                        className="btn btn-secondary h-100"
                        style={{width: viewMode === 'default' ? "120px" : "150px"}}
                            onClick={() => {
                                if (viewMode === 'default') {
                                    props?.close(); 
                                    setSelectedStockTake(null);
                                } else {
                                    handleBackToStockTakes();
                                }
                            }}
                       >
                      { viewMode === 'default' ? "Back to Stores" : "Back To Stock Takes" }
                     </button>
                     
                     { viewMode === "default" && allClosed &&
                      <button
                          className="btn btn-secondary h-100"
                            onClick={() => {handleCreationProcess(props?.isCycleCount)}}
                          // onClick={() => {handleCreateStockTakeSubmit()}}
                        >
                         {props?.isCycleCount === true && "Create Cycle Count" } 
                         {props?.isCycleCount === false && "Create Stock Take" } 
                      </button>
                     }
                    
                  </div>
                  <br></br>                                       
                  <div style={{ overflowY: "auto" , marginBottom: "4px", position: "relative", backgroundColor: "#fff", borderBottom: "1px solid #dee6ed" }}>
                    { /* Stock Take Table */ }
                    <table className="table table-bordered">
                            <thead>                           
                                <tr>
                                    <th style={thStyle}>Reference</th>
                                    <th style={thStyle}>Location</th>
                                    <th style={thStyle}>Status</th>
                                    <th style={thStyle}>Created</th>
                                    <th style={thStyle}>Comment</th>
                                    <th style={{...thStyle, width: "100px"}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {loading && viewMode === "default" ? (
                              <>
                              <tr>
                                <td colSpan={6} className="text-center">
                                  <div className="spinner-border" role="status">
                                     <span className="visually-hidden">Loading...</span>
                                  </div>
                                </td>
                              </tr>
                              {hasBeenCompleted && 
                                <tr style={{border:"none"}}>
                                 <td colSpan={6} className="text-center">
                                  <span className="" style={{fontSize:"15px", fontWeight:"600"}} >We are currently processing your request...</span>
                                 </td>
                                </tr>
                               }
                               </>
                            ) : (
                              <>
                                {viewMode === "default" &&
                                  stockTakeState.map((stakes: IStockTake) => (
                                    <tr key={stakes.id}>
                                      <td style={tdStyle}>{stakes.reference}</td>
                                      <td style={tdStyle} >{stakes.location}</td>
                                      <td
                                        style={{
                                          ...tdStyle,
                                          backgroundColor: stakes.status === "CANCELLED" ? "rgb(247, 84, 114)" : undefined,
                                        }}
                                        className={`text-white text-center ${
                                          stakes.status === "OPEN"
                                            ? "bg-success"
                                            : stakes.status === "CLOSED"
                                            ? "bg-warning"
                                            : ""
                                        }`}
                                      >
                                        {stakes.status}
                                      </td>
                                      <td style={tdStyle}>{formatDateFull(stakes.created)}</td>
                                      <td style={tdStyle}>{stakes.comment}</td>
                                      <td style={tdStyle} className="d-flex gap-1">
                                   
                                        { stakes.status === "OPEN" && !stakes.file_uploaded ? (
                                             <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='File Upload'
                                               onClick={() => handleFileView(stakes)}
                                              >
                                                <FileUp style={{ width: "17px", height: "17px", }}  /> 
                                              </button>
                                          ) : (
                                            <DisabledFileBtn/>
                                        )} 


                                        { stakes.status === "OPEN" ? (
                                             <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Scan'
                                               onClick={() => handleScanView(stakes)}
                                              >
                                                <ScanLine style={{ width: "17px", height: "17px", }}  /> 
                                              </button>
                                          ) : (
                                            <DisabledScanBtn/>
                                        )} 



                                        { stakes.status !== "OPEN" ? (
                                             <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Report'
                                               onClick={() => handleReportView(stakes)}
                                              >
                                                <FileBarChart style={{ width: "17px", height: "17px", }}  /> 
                                              </button>
                                          ) : (
                                            <DisabledReportBtn/>
                                        )} 
                                     

                                        { stakes.status === "OPEN" ? (
                                             <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Close Record'
                                               onClick={() => handleCloseView(stakes)}
                                              >
                                                <Check style={{ width: "17px", height: "17px", }}  /> 
                                              </button>
                                          ) : (
                                            <DisabledCheckBtn/>
                                        )}  

                                         { stakes.status === "OPEN" ? (
                                             <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Remove Record'
                                               onClick={() => handleDeleteView(stakes)}
                                              >
                                                <X style={{ width: "17px", height: "17px", }}  /> 
                                              </button>
                                          ) : (
                                            <DisabledDeleteBtn/>
                                        )}  

                                      </td>
                                    </tr>
                                  ))}
                                {/* selected stock take views */}
                                {selectedStockTake && viewMode !== "default" && (
                                  <>
                                    <tr key={selectedStockTake.id}>
                                      <td style={tdStyle}>{selectedStockTake.reference}</td>
                                      <td style={tdStyle}>{selectedStockTake.location}</td>
                                      <td style={tdStyle}
                                        className={`text-white text-center ${
                                          selectedStockTake.status === "OPEN"
                                            ? "bg-success"
                                            : selectedStockTake.status === "CLOSED"
                                            ? "bg-warning"
                                            : ""
                                        }`}
                                      >
                                        {selectedStockTake.status}
                                      </td>
                                      <td style={tdStyle}>{formatDateFull(selectedStockTake.created)}</td>
                                      <td style={tdStyle}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                      <td colSpan={7} style={{ textAlign: "center" }}>
                                        
                                        {/* Quantity Form (only in scan mode and when showing scanned item details) */}
                                        {viewMode === 'scan' && selectedScannedItem && showCustomQuantitySection ? (
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                handleQuantitySubmit(selectedStockTake.id);
                                            }}
                                            className="p-3 border rounded bg-light"
                                            style={{ display: 'inline-block', textAlign: 'left', minWidth: '600px' }}
                                        >
                                            <div className="mb-3 position-relative">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h6 className="mb-0" style={{ fontWeight: 600 }}>Scanned Item Details</h6>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{ width: '28px', height: '28px' }}
                                                    onClick={handleCloseForm}
                                                    aria-label="Close"
                                                    >
                                                <X size={16} />
                                                </button>
                                            </div>
                                            <hr className="my-2" />

                                            <div className="row">
                                                <div className="col-md-6 mb-2">
                                                <label className="form-label mb-0"><strong>Name:</strong></label>
                                                <div className="form-control-plaintext">{selectedScannedItem.name}</div>
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                <label className="form-label mb-0"><strong>Item Group:</strong></label>
                                                <div className="form-control-plaintext">{selectedScannedItem.item_group}</div>
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                <label className="form-label mb-0"><strong>Item Code:</strong></label>
                                                <div className="form-control-plaintext">{selectedScannedItem.item_code}</div>
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                <label className="form-label mb-0"><strong>Barcode:</strong></label>
                                                <div className="form-control-plaintext">{selectedScannedItem.barcode}</div>
                                                </div>
                                            </div>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <label htmlFor="custom_quantity" className="form-label mb-0 me-2"><strong>Quantity:</strong></label>
                                                <input
                                                type="number"
                                                id="custom_quantity"
                                                name="custom_quantity"
                                                min={1}
                                                value={customQuantity}
                                                onChange={(e) => setCustomQuantity(e.target.value)}
                                                className="form-control form-control-sm"
                                                style={{ width: '100px' }}
                                                />
                                            </div>

                                            <button type="submit" className="btn btn-dark btn-sm ms-3">
                                                Save Quantity
                                            </button>
                                            </div>
                                        </form>
                                        ) : (
                                        // Label + input section (standard layout)
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <span style={{ marginRight: '10px' }}>
                                            {viewMode === 'scan' ? 'Scan Code:' : 'Upload File:'}
                                            </span>

                                            {viewMode === 'scan' ? (
                                            <input
                                                ref={scanRef}
                                                id="scan_code"
                                                name="scan_code"
                                                type="text"
                                                autoComplete="off"
                                                className="form-control form-control-md w-25"
                                                style={{ margin: 0 }}
                                                onKeyDown={(e) => handleScanKeyDown(e, selectedStockTake?.id)}
                                            />
                                            ) : (
                                               <>
                                              {!previewFileUpload ? (
                                                <>
                                                  <input
                                                    ref={fileRef}
                                                    id="file_codes"
                                                    name="file_codes"
                                                    type="file"
                                                    className="form-control form-control-md w-25"
                                                    style={{ margin: 0 }}
                                                    onChange={handleFolderChange}
                                                    disabled={previewFileUpload}
                                                  />

                                                  <button
                                                    className="btn btn-light"
                                                    style={{ width: "120px", margin: "4px", border: "1px solid #d3d3d3" }}
                                                    onClick={handleFilePreview}
                                                    disabled={selectedFile === null}
                                                  >
                                                    Preview File
                                                  </button>
                                                </>
                                              ) : (
                                                <>

                                                  <input
                                                    ref={fileRef}
                                                    id="file_codes"
                                                    name="file_codes"
                                                    type="file"
                                                    accept=".xlsx"
                                                    className="form-control form-control-md w-25"
                                                    style={{ margin: 0 }}
                                                    onChange={handleFolderChange}
                                                    disabled={previewFileUpload}
                                                  />

                                                  <button
                                                    className="btn btn-light"
                                                    style={{ width: "120px", margin: "4px", border: "1px solid #d3d3d3" }}
                                                    onClick={() => handleFileSubmit(selectedStockTake?.id)}
                                                    disabled={selectedFile === null || previewUploadedFileData.length === 0}
                                                    title="Upload File"
                                                  >
                                                    Upload File
                                                  </button>

                                                  <button
                                                    className="btn btn-light"
                                                    style={{ width: "120px", margin: "4px", border: "1px solid #d3d3d3" }}
                                                    title="Cancel File Upload"
                                                    onClick={handleCancelFilePreview}
                                                  >
                                                    Cancel
                                                  </button>
                                                </>
                                              )}
                                            </>
                                            )}
                                        </div>
                                        )}
                                            
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </>
                            )}
                          </tbody>
                      </table>

                      {selectedStockTake && viewMode !== "default" && viewMode === "file" && previewFileUpload === true && !previewFailed &&
                        <div style={{ width: '100%' }}>
                        <h5 className="mt-3 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1">
                            File Preview
                        </h5>
                         <table className="table table-bordered">
                            <thead>                           
                                <tr>
                                    <th style={thStyle}>Item Name</th>
                                    <th style={thStyle}>Item Code</th>
                                    <th style={thStyle}>Item Barcode</th>
                                    <th style={{...thStyle, width: '100px'}}>Qty</th>
                                </tr>                                                             
                            </thead>
                            <tbody>
                              {previewLoading ? (
                               <tr>
                                    <td colSpan={4} className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                 stockTakeLineState && previewUploadedFileData.length > 0 && previewUploadedFileData.map((previewLine: IUploadFilePreviewItem) => {
      
                                    return (
                                    <tr key={previewLine.barcode}>
                                        <td style={tdStyle}>{previewLine.name}</td>
                                        <td style={tdStyle}>{previewLine.itemCode}</td>
                                        <td style={tdStyle}>{previewLine.barcode}</td>
                                        <td style={tdStyle}>{previewLine.count}</td>
                                    </tr>
                                     );
                                  })
                               )}
                            </tbody>
                          </table>
                        </div>
                      }

                      {selectedStockTake && viewMode !== "default" && viewMode === "scan" &&
                      <div style={{ overflowY: "auto" , marginBottom: "4px", position: "relative", backgroundColor: "#fff", borderBottom: "1px solid #dee6ed" }}>
                        <table className="table table-bordered">
                            <thead>                           
                                <tr>
                                    <th style={thStyle}>Item Name</th>
                                    <th style={thStyle}>Item Code</th>
                                    <th style={thStyle}>Item Barcode</th>
                                    <th style={thStyle}>Created</th>
                                    <th style={{...thStyle, width: '100px'}}>Qty</th>
                                    {selectedStockTake?.status === "OPEN" && (
                                      <th style={thStyle}>Actions</th>
                                    )}
                                </tr>                                                             
                            </thead>
                            <tbody>
                            {loading ? (
                               <tr>
                                    <td colSpan={selectedStockTake?.status === "OPEN" ? 6 : 5} className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                stockTakeLineState && stockTakeLineState.length > 0 && stockTakeLineState.map((stakeline: IStockTakeLine) => {
                                   const isEditing = editingRowId === stakeline.id;

                                    return (
                                    <tr key={stakeline.id}>
                                        <td style={tdStyle} >{stakeline.item_name}</td>
                                        <td style={tdStyle}>{stakeline.item_code}</td>
                                        <td style={tdStyle}>{stakeline.item_barcode}</td>
                                        <td style={tdStyle}>{formatDateFull(stakeline.created)}</td>
                                        <td style={tdStyle} className="text-end">
                                            {isEditing ? (
                                               <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                  <input
                                                  type="number"
                                                  className="form-control form-control-sm"
                                                  style={{ maxWidth: "80px", fontSize: "0.85rem", padding: "0.25rem" }}
                                                  value={inputDraft[stakeline.id] ?? ''}
                                                  onChange={(e) => handleQtyDraftChange(stakeline.id, e.target.value)}
                                                  onBlur={() => handleBlur(stakeline.id)}
                                                  autoFocus
                                                  onClick={(e) => (e.target as HTMLInputElement).select()}
                                                  onFocus={(e) => (e.target as HTMLInputElement).select()}
                                                  />
                                                 </div>
                                             ) : (
                                                stakeline.qty
                                             )}
                                        </td>
                                        {selectedStockTake?.status === "OPEN" && (
                                          <td className='d-flex gap-1'>
                                             {isEditing ? (
                                                <>
                                                { !inputDraft[stakeline.id]?.trim() ? (
                                                        <DisabledSaveQtyBtn/>
                                                    ) : (
                                                        <button
                                                        className="btn btn-secondary h-100 d-flex align-items-center gap-1"
                                                        onClick={() => handleSaveClick(stakeline.id)}
                                                        title="Save Quantity"
                                                        >
                                                        <Save style={{ width: "17px", height: "17px", }} />
                                                        </button>
                                                    )
                                                }

                                                <button
                                                    className="btn btn-secondary h-100 d-flex align-items-center gap-1"
                                                    onClick={() => setEditingRowId(null)}
                                                    title="Cancel"
                                                >
                                                    <X style={{ width: "17px", height: "17px", }} />
                                                </button>
                                                </>
                                            ) : editingRowId === null ? (
                                                <button
                                                className="btn btn-secondary h-100 d-flex align-items-center gap-1"
                                                onClick={() =>
                                                    handleEditClick(
                                                    stakeline.id,
                                                    stakeline.qty ?? 0
                                                    )
                                                }
                                                title="Edit Quantity"
                                                >
                                                <Pencil style={{ width: "17px", height: "17px", }} />
                                                </button>
                                            ) : (<DisabledEditQtyBtn/>) }
                                            
                                          </td>
                                         )}
                                    </tr>
                                     );
                                  })
                             )}
                            </tbody>
                          </table>
                        </div>
                      }
                  </div>
                </CardBody>


                 {/* Modal structure */}
                 <>
                 <Modal show={showModal} onHide={() => {
                      setShowModal(false); 
                      setCheckSelectedStockTake(null);
                      }}>
                            <Modal.Header closeButton>
                            <Modal.Title>{props?.isCycleCount ? "Cycle Count" : "Stock Take" }: [ {checkSelectedStockTake?.reference} ] </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p style={{ fontSize: "15px", paddingLeft: "4px", fontWeight: "900" }}><b>{`"Are you sure you want to delete this ${props?.isCycleCount ? "cycle count" : "stock take"} record?"`}</b></p>   
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Reference</b></th>
                                            <th><b>Location</b></th>
                                            <th><b>Status</b></th>
                                            <th><b>Created</b></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                          <tr>
                                            <td>{checkSelectedStockTake?.reference}</td>
                                            <td>{checkSelectedStockTake?.location}</td>
                                            <td className={`text-white text-center ${checkSelectedStockTake?.status === "OPEN" ? "bg-success" : checkSelectedStockTake?.status === "CLOSED" ? "bg-warning" : ""}`}>
                                              {checkSelectedStockTake?.status}
                                            </td>
                                            <td>{checkSelectedStockTake?.created}</td>
                                        </tr>
                                    </tbody>
                                </table>       
                            </Modal.Body>
                            <Modal.Footer>
                            <Button variant="primary" onClick={() => {setShowModal(false); handleDeleteSubmit(checkSelectedStockTake?.id ?? ""); } }>
                                Confirm
                            </Button>
                            <Button variant="secondary" onClick={() => {
                              setShowModal(false);  
                              setCheckSelectedStockTake(null);
                              } }>
                                Cancel
                            </Button>
                            </Modal.Footer>
                        </Modal>
                    </> 
                    

                  {/* Modal structure Closing Record */}
                    <>
                      <Modal
                        show={showCloseRecordModal}
                        onHide={() => {
                          setShowCloseRecordModal(false);
                          setComment("");
                        }}
                        onExited={() => {
                          setComment("");
                          setSelectedStockTakeValid(null);

                           if (shouldResetAfterClose) {
                            setComment("");
                            setSelectedStockTakeValid(null);
                            setStockTakeLineState([]);
                            setShouldResetAfterClose(false);
                          }
                        }}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>
                            {props?.isCycleCount ? "Cycle Count" : "Stock Take"}: [ {selectedStockTakeValid?.reference} ]
                          </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%" }}>
                          {lineDataCheckLoading ? (
                            <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px" }} >
                                <div className="spinner-border" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                                <p style={{ marginTop: "10px", fontWeight: 600 }}>
                                  Transaction Processing... Please wait. 
                                </p>
                            </div>
                          ) : !stockTakeLineState || stockTakeLineState.length === 0 ? (
                            <div className="informational-message-section">
                              <strong>Note:</strong> Unable to close the record. At least one line must
                              be added to it before submission.
                            </div>
                          ) : (
                            <>
                              <p style={{ fontSize: "15px", paddingLeft: "4px", fontWeight: "900" }}>
                                <b>
                                  {`Are you sure you want to close this ${ props?.isCycleCount ? "cycle count" : "stock take" } record?`}
                                </b>
                              </p>
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th><b>Reference</b></th>
                                    <th><b>Location</b></th>
                                    <th><b>Status</b></th>
                                    <th><b>Created</b></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{selectedStockTakeValid?.reference}</td>
                                    <td>{selectedStockTakeValid?.location}</td>
                                    <td
                                      className={`text-white text-center ${
                                        selectedStockTakeValid?.status === "OPEN"
                                          ? "bg-success"
                                          : selectedStockTakeValid?.status === "CLOSED"
                                          ? "bg-warning"
                                          : ""
                                      }`}
                                    >
                                      {selectedStockTakeValid?.status}
                                    </td>
                                    <td>{selectedStockTakeValid?.created}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <hr />
                              <p style={{ fontSize: "15px", paddingLeft: "4px", fontWeight: "900" }}>
                                <b>
                                  {`Would you like to add a comment for this ${
                                    props?.isCycleCount ? "cycle count" : "stock take"
                                  } record?`}
                                </b>
                              </p>
                              <textarea
                                ref={commentRef}
                                value={comment}
                                className="form-control"
                                onChange={handleChange}
                                placeholder="Add your comment here..."
                                style={{ width: "100%", fontSize: "15px" }}
                              />
                            </>
                          )}
                        </div>
                      </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            disabled={!stockTakeLineState || stockTakeLineState.length === 0}
                            onClick={() => {
                              setShowCloseRecordModal(false);
                              handleCloseSubmit(selectedStockTakeValid?.id ?? "");
                              setShouldResetAfterClose(true);
                            }}
                          >
                            Confirm
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={() => {
                              setShowCloseRecordModal(false);
                              setShouldResetAfterClose(true);
                            }}
                          >
                            Cancel
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>

              


                 {/* Modal Report Preview */}
                 <>
                 <Modal show={showReportPreviewModal} onHide={() => {
                  setShowReportPreviewModal(false); 
                  setSelectedReportReview([]);
                  // setSelectedStockTake(null);
                  }} 
                          size="xl" 
                          aria-labelledby="example-custom-modal-styling"
                          className="custom-modal-width">
                        <Modal.Header closeButton>
                        <Modal.Title>
                           {props?.isCycleCount ? "Cycle Count" : "Stock Take"}: [ {selectedStockTake?.reference} ] - Report Preview 
                           <button 
                              className="btn btn-secondary" 
                              style={{ margin: "0px 0px 0px 21px"}} 
                              disabled={downLoadLoading}
                              onClick={() => {
                                if(selectedStockTake) handleReportDownLoad(selectedStockTake);
                              }}
                            >
                            Download Report
                          </button>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {downLoadLoading && 
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", width: "100%" }}>
                                <div style={{ width: "100%", textAlign: "center" }}>
                                  <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </div>
                                <div className="report-downloading-message-display" style={{ width: "100%", textAlign: "center" }}>
                                  <span className="download-message" style={{ color: "green" }}>
                                     Processing your report for download...
                                  </span>
                                </div>
                              </div>                              
                            }
                            { showErrorAlert && <ShowErrorAlert message={responseErrorMessage} /> } 
                            <table className="table table-bordered">
                                <thead>
                                      <tr>
                                          <th></th>
                                          <th><b className='report-th-bolder'>TOTALS:</b></th>
                                          <th className='report-th-not-bold'>{totalOnHandStart}</th>
                                          <th className='report-th-not-bold'>{totalCommittedStart}</th>
                                          <th className='report-th-not-bold'>{totalAvailableStart}</th>
                                          <th className='report-th-not-bold'>{totalScannedQty}</th>
                                          <th className='report-th-not-bold'>{totalScannedVarience}</th>
                                          <th className='report-th-not-bold'>{totalOnHandFinal}</th>
                                          <th className='report-th-not-bold'>{totalCommittedFinal}</th>
                                          <th className='report-th-not-bold'>{totalActaulVarience}</th>
                                      </tr>
                                      <tr>
                                          <th><b className='report-th-bolder'>SKU</b></th>
                                          <th><b className='report-th-bolder'>Name</b></th>
                                          <th><b className='report-th-bolder'>On Hand (Start)</b></th>
                                          <th><b className='report-th-bolder'>Committed (Start)</b></th>
                                          <th><b className='report-th-bolder'>Available (Start)</b></th>
                                          <th><b className='report-th-bolder'>Scanned Qty</b></th>
                                          <th><b className='report-th-bolder'>Scanned Varience</b></th>
                                          <th><b className='report-th-bolder'>On Hand (Final)</b></th>
                                          <th><b className='report-th-bolder'>Committed (Final)</b></th>
                                          <th><b className='report-th-bolder'>Actaul Varience</b></th>
                                      </tr>
                                </thead>
                                <tbody>
                                {reportLoading ? (
                                    <tr>
                                          <td colSpan={10} className="text-center">
                                              <div className="spinner-border" role="status">
                                                  <span className="visually-hidden">Loading...</span>
                                              </div>
                                          </td>
                                      </tr>
                                  ) : (
                                    selectedReportReview && selectedReportReview.map((report:IStockReportReview) => (
                                      <tr key={report.item_code}>
                                         <td style={{ whiteSpace: 'nowrap' }}>{report.item_code}</td>
                                         <td style={{ whiteSpace: 'nowrap' }}>{report.name}</td>
                                         <td>{report.on_hand_start}</td>
                                         <td>{report.committed_start}</td>
                                         <td>{report.available_start}</td>
                                         <td>{report.scanned_qty}</td>
                                         <td>{report.scanned_variance}</td>
                                         <td>{report.on_hand_final}</td>
                                         <td>{report.committed_final}</td>
                                         <td>{report.actual_variance}</td>
                                      </tr>
                                     ))
                                  )}
                                </tbody>
                            </table>       
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={() => {
                          setShowReportPreviewModal(false);  
                          setSelectedReportReview([]);
                          // setSelectedStockTake(null);
                          }}>
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>
                  </> 



                {/* Modal Create Stock Take */}
                <>
                   <Modal
                      show={showStockTakeCreationModal}
                      onHide={() => {
                        setShowStockTakeCreationModal(false);
                        setSelectedCategories([]);
                      }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Create Stock Take Transaction</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div>
                          <label className="mb-2 d-block" style={{ fontWeight: 600, fontSize: "14px" }}>
                            Select Stock Take Categories:
                          </label>
                          <ul className="list-unstyled mb-0" style={{ border: "1px solid #dee2e6", borderRadius: "5px", padding: "8px", backgroundColor: "#f8f9fa" }}>
                            {/* All Option */}
                            <li key="all" className="mb-2" style={{ backgroundColor: "#ffffff", padding: "6px 8px", borderRadius: "3px" }}>
                              <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer", lineHeight: "1.4", fontSize: "15px" }}>
                                <input type="checkbox" className="form-check-input" checked={allSelected} onChange={(e) => handleCategoryChange("All", e.target.checked)} style={{ verticalAlign: "middle", margin: 0 }}/>
                                <span>All</span>
                              </label>
                            </li>
                            {/* Dynamic Categories */}
                            {fetchedCategories.map((category) => (
                              <li key={category.code} className="mb-2" style={{ backgroundColor: "#ffffff", padding: "6px 8px",  borderRadius: "3px" }}>
                                <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer", lineHeight: "1.4", fontSize: "15px" }}>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={selectedCategories.includes(Number(category.code))}
                                    onChange={(e) => handleCategoryChange(category, e.target.checked)}
                                    style={{ verticalAlign: "middle", margin: 0 }}
                                  />
                                  <span>{category.name}</span>
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="primary"
                          disabled={selectedCategories.length === 0}
                          onClick={() => {
                            handleCreateStockTakeSubmit();
                            setShowStockTakeCreationModal(false);
                          }}
                        >
                          Confirm
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={() => {
                            setShowStockTakeCreationModal(false);
                            setSelectedCategories([]);
                          }}
                        >
                          Cancel
                        </Button>
                      </Modal.Footer>
                    </Modal>
                </> 
                {/* Modal Create Stock Take */}


                {/* Modal HQ Create Cycle Count */}
                 <>
                 <Modal show={showHqCycleCountCreationModal} onHide={() => {
                   handleCloseHqCycleCountCreationModal();
                  }} >
                        <Modal.Header closeButton>
                          <Modal.Title>
                             Create Cycle Count Transaction. 
                          </Modal.Title>
                        </Modal.Header>
                         <Modal.Body>
                          <div className="informational-message-section">
                               <strong>Instructions:</strong>  
                               <p>You can optionally choose which article codes will be included in the cycle count using one of the methods bellow.</p>
                               <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                                 <li><strong>Upload File</strong><br/>
                                     Upload an Excel file containing the article codes to be counted.<br/>
                                     ( <strong>Note</strong>: Each article code should follow the format <strong>Style - Color</strong>. )
                                 </li>
                                 <li><strong>Manual Insert</strong><br/>
                                     Enter the article codes directly in the input interface and click <strong>Create</strong> when done.<br/>
                                </li>
                              </ul>
                              <div style={{ marginTop: "8px", color: "gray" }}>
                                Once ready, click <strong>Create</strong> to continue.
                              </div>
                          </div>

                            {/* Option selector */}
                            <div style={{ backgroundColor: "#f8f9fa", padding: "6px 8px", borderRadius: "3px", border: '1px solid #dee2e6' }}>
                            <div className="d-flex gap-3 mt-3 mb-3">
                              <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer", lineHeight: "1.6", fontSize: "15px" }}>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selectedMethod === "file"}
                                  onChange={() => handleRadioClick("file")}
                                  style={{ verticalAlign: "middle", margin: 0 }}
                                />
                                <span>Upload File</span>
                              </label>

                              <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer", lineHeight: "1.6", fontSize: "15px" }}>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selectedMethod === "manual"}
                                  onChange={() => handleRadioClick("manual")}
                                  style={{ verticalAlign: "middle", margin: 0 }}
                                />
                                <span>Manually Insert</span>
                              </label>
                            </div>



                            {/* File upload section */}
                            {selectedMethod === "file" && (
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%" }}>
                                <label htmlFor="file_article_codes" style={{ marginBottom: '6px', fontWeight: 'bold', marginLeft: '4px' }}>
                                  Upload File Of Article Codes:
                                  <span style={{ color: '#c0392b', fontWeight: 'normal', marginLeft: '8px' }}>
                                    * Only .xlsx files supported
                                  </span>
                                </label>
                                <input
                                  ref={fileArticleRef}
                                  id="file_article_codes"
                                  name="file_article_codes"
                                  type="file"
                                  accept=".xlsx"
                                  className="form-control form-control-md w-80"
                                  onChange={handleFolderChange}
                                />
                              </div>
                            )}

                            {/* Manual insert section */}
                              {selectedMethod === "manual" && (
                                <div>
                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%", marginTop: "10px" }}>
                                    <label htmlFor="article_codes_text" style={{ marginBottom: "6px", fontWeight: "bold", marginLeft: "4px" }}>
                                      Manually Insert Article Codes:
                                    </label>
                                    <div style={{display: "flex", alignItems: "center", width: "100%", gap: "8px" }}>
                                      <input
                                        id="article_codes_text"
                                        name="article_codes_text"
                                        type="text"
                                        value={newArticleCode}
                                        onChange={(e) => setNewArticleCode(e.target.value)}
                                        className="form-control form-control-md"
                                        style={{ flex: 1 }}
                                        placeholder='Insert Article Code...'
                                      />
                                      <button
                                        type="button"
                                        className="btn btn-primary d-inline-flex align-items-center justify-content-center"
                                        onClick={handleAddArticleCode}
                                        title='Add Article Code'
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>

                                  {/* Table */}
                                  <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd", marginTop: "8px" }}>
                                    <table className="table table-bordered table-sm">
                                      <thead className="table-light">
                                        <tr>
                                          <th style={{ color: "gray" }}>Article Code</th>
                                          <th style={{ color: "gray", width: "70px" }}>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {articleCodes.map((code, idx) => (
                                          <tr key={idx}>
                                            <td>{code}</td>
                                             <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  }}>
                                              <button
                                                type="button"
                                                className="btn btn-secondary d-inline-flex align-items-center justify-content-center"
                                                onClick={() => handleDeleteArticleCode(code)}
                                                title="Remove Article Code"
                                              >
                                                <X style={{ width: 17, height: 17 }} />
                                              </button>
                                            </td>
                                          </tr>
                                        ))}

                                        {articleCodes.length === 0 && (
                                          <tr>
                                            <td colSpan={2} style={{ textAlign: "center", color: "gray" }}>
                                              No article codes added
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                             </div>
                          </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary"  onClick={() => {  setShowHqCycleCountCreationModal(false); handleCreateCycleCountSubmit(); }}> 
                                Create
                            </Button>
                            <Button variant="secondary"  
                               onClick={() => { handleCloseHqCycleCountCreationModal();  } }
                             >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                  </> 
                  {/* Modal Create Stock Take */}
        </Card>
    </>
  )
}

